import useCapabilities, {
  useCanManageApplications,
  useCanManageJobPostsBool,
  useCanViewCareerPlanBool,
  useCanViewCareerPreferencesBool,
  useCanViewCommitteesBool,
  useCanViewCompensationProfilesBool,
  useCanViewJobPostsBool,
  useCanViewOrdersBool,
  useCanViewPersonBillingBool,
  useCanViewPersonCareerBool,
  useCanViewPersonContactBool,
  useCanViewPersonEducationBool,
  useCanViewPersonEventsBool,
  useCanViewPersonChangeHistoryBool,
  useCanViewPersonDocumentsBool,
  useCanViewPersonGroupsBool,
  useCanViewPersonInsightsBool,
  useCanViewPersonMembershipBool,
  useCanViewPersonNotesBool,
  useCanViewPersonSuspensionHistoryBool
} from "@/hooks/useCapabilities";

/**
 * Person-profile read bits plus mixed-nav ORs for chrome (heading, overview,
 * side sheet, Manage Person nav, global search). Route deny stays slice-local.
 */
export function usePersonProfileReadCapabilities() {
  const { loaded } = useCapabilities();
  const canViewPersonContact = useCanViewPersonContactBool();
  const canViewPersonMembership = useCanViewPersonMembershipBool();
  const canViewPersonSuspensionHistory = useCanViewPersonSuspensionHistoryBool();
  const canViewPersonEducation = useCanViewPersonEducationBool();
  const canViewPersonCareer = useCanViewPersonCareerBool();
  const canViewPersonEvents = useCanViewPersonEventsBool();
  const canViewPersonBilling = useCanViewPersonBillingBool();
  const canViewPersonGroups = useCanViewPersonGroupsBool();
  const canViewPersonNotes = useCanViewPersonNotesBool();
  const canViewPersonChangeHistory = useCanViewPersonChangeHistoryBool();
  const canViewPersonDocuments = useCanViewPersonDocumentsBool();
  const canViewPersonInsights = useCanViewPersonInsightsBool();
  const canViewOrders = useCanViewOrdersBool();
  const canManageApplications = useCanManageApplications();
  const canViewCommittees = useCanViewCommitteesBool();
  const canViewCareerPlan = useCanViewCareerPlanBool();
  const canViewCareerPreferences = useCanViewCareerPreferencesBool();
  const canViewCompensationProfiles = useCanViewCompensationProfilesBool();
  const canManageJobPosts = useCanManageJobPostsBool();
  const canViewJobPosts = useCanViewJobPostsBool();

  return {
    loaded,
    canViewPersonContact,
    canViewPersonMembership,
    canViewPersonSuspensionHistory,
    canViewPersonEducation,
    canViewPersonCareer,
    canViewPersonEvents,
    canViewPersonBilling,
    canViewPersonGroups,
    canViewPersonNotes,
    canViewPersonChangeHistory,
    canViewPersonDocuments,
    canViewPersonInsights,
    canViewOrders,
    canManageApplications,
    canViewCommittees,
    canViewCareerPlan,
    canViewCareerPreferences,
    canViewCompensationProfiles,
    canManageJobPosts,
    canViewJobPosts,
    showMembershipNav: canViewPersonMembership || canManageApplications || canViewCommittees,
    showCareerNav:
      canViewPersonCareer ||
      canViewCareerPlan ||
      canViewCareerPreferences ||
      canViewCompensationProfiles ||
      canManageJobPosts ||
      canViewJobPosts,
    showBillingNav: canViewOrders || canViewPersonBilling,
    showEventsNav: canViewPersonEvents
  };
}
